import axios from 'axios';


/**
 * 获取学习报告
 * @param 有参数
 * @returns {json}
 */
export const getReport = params => {
  return axios.get('/yongpai-service/api/iapc/report',{params : params});
};

/**
 * 获取更多学习内容
 * @param 有参数
 * @returns {json}
 */
export const getReportMore = params => {
  return axios.get('/yongpai-service/api/iapc/more_report',{params : params});
};

/**
 * 学习概况
 * @returns {json}
 */
export const getStudySummary = params => {
  return axios.get('/yongpai-service/api/iapc/study_summary',{params : params});
};




// WEBPACK FOOTER //
// ./src/api/iapc/index.js